// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format11 } from '../../constants';

/** Isle of Man */
const IM: PhoneNumberData = [
  44,
  'IM',
  10,
  format11,
  /^(?:74576|(?:16|7[56])24)/,
];

export default IM;
